import { ReactNode } from 'react';
import { Box, BoxProps, ListItem } from '@chakra-ui/react';
import { Text, Colors, Icon, IconNameEnum } from '@mercator-gcp/grout';
import { capitalize } from 'lodash';
import AIMarker from 'components/elements/AIMarker';
import Tooltip from 'components/elements/Tooltip';
import { FlexRow } from 'components/layout/FlexRow';
import { useDashboardItemSelection } from 'components/widgets/Dashboard/useDashboardItemSelection';

const rowItemStyle = (isActive: boolean, isSubsection?: boolean) => ({
  display: 'flex',
  justifyContent: 'space-between',
  backgroundColor: isActive ? Colors.ArmyGreen900 : 'transparent',
  paddingY: 'padding_4',
  paddingX: 'padding_8',
  paddingLeft: isSubsection ? 'padding_24' : 'padding_8',
  color: Colors.TextWhite,
  '.flyout-item-menu': {
    opacity: '0',
  },
  _hover: {
    backgroundColor: Colors.ArmyGreen900,
    cursor: 'pointer',
    '.flyout-item-menu': {
      opacity: 1,
    },
  },
});

const itemLabelContainerStyle = {
  gap: 'padding_8',
};

const itemLabelStyle = {
  display: 'inline-block',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  backgroundColor: 'transparent',
  maxWidth: '190px',
};

type TSectionItem = {
  label: string;
  numProjects?: number;
  isActive?: boolean;
  iconName?: IconNameEnum;
  isSubsection?: boolean;
  onClick: () => void;
  menu?: ReactNode;
  sx?: BoxProps['sx'];
  showAiMarker?: boolean;
};

const SectionItem = ({
  label: collectionName,
  numProjects,
  isActive = false,
  iconName,
  isSubsection,
  onClick: onClickProp,
  menu,
  sx,
  showAiMarker = false,
}: TSectionItem) => {
  const { handleItemSelectionSideEffect } = useDashboardItemSelection();
  const onClick = () => {
    handleItemSelectionSideEffect();
    onClickProp();
  };

  return (
    <ListItem sx={{ ...rowItemStyle(isActive, isSubsection), ...sx }} onClick={onClick}>
      <FlexRow sx={itemLabelContainerStyle}>
        {iconName && <Icon name={iconName} />}
        {showAiMarker && (
          <AIMarker
            labelOverride="This saved search was created by Scout AI"
            fill={Colors.TextWhite}
          />
        )}
        <Tooltip
          tooltipText={capitalize(collectionName)}
          shouldRenderTooltip={collectionName.length > 30}
        >
          <Text sx={itemLabelStyle}>{collectionName}</Text>
        </Tooltip>
      </FlexRow>
      {typeof numProjects === 'number' && <Text>{numProjects}</Text>}
      {menu && <Box className="flyout-item-menu">{menu} </Box>}
    </ListItem>
  );
};

export default SectionItem;
